import React from 'react';

export function LocationFields({ form, onChange, locations, allowSaveLocation = true, idPrefix = '' }) {
  const fieldId = (name) => `${idPrefix}${name}`;
  return (
    <div className="form-grid">
      <div className="form-field">
        <span className="field-label">Saved Location</span>
        <select id={fieldId('locationId')} name="locationId" value={form.locationId} onChange={onChange} className="input">
          <option value="">-- Not Selected --</option>
          {locations.map(loc => (
            <option key={loc.id} value={loc.id}>{loc.name}</option>
          ))}
        </select>
      </div>

      <div className="form-field">
        <span className="field-label">📍 Location Name</span>
        <input id={fieldId('locationName')} name="locationName" value={form.locationName} onChange={onChange} className="input" required />
      </div>

      <div className="form-field">
        <span className="field-label">Street</span>
        <input id={fieldId('locationStreet')} name="locationStreet" value={form.locationStreet} onChange={onChange} className="input" required />
      </div>

      <div className="form-field">
        <span className="field-label">City</span>
        <input id={fieldId('locationCity')} name="locationCity" value={form.locationCity} onChange={onChange} className="input" />
      </div>

      <div className="form-field">
        <span className="field-label">Postcode</span>
        <input id={fieldId('locationPostcode')} name="locationPostcode" value={form.locationPostcode} onChange={onChange} className="input" required />
      </div>

      <div className="form-field">
        <span className="field-label">Country</span>
        <input id={fieldId('locationCountry')} name="locationCountry" value={form.locationCountry} onChange={onChange} className="input" required />
      </div>

      {allowSaveLocation && !form.locationId && (
        <div className="checkbox-row">
          <input type="checkbox" id={fieldId('saveLocation')} name="saveLocation" checked={form.saveLocation} onChange={onChange} />
          <label htmlFor={fieldId('saveLocation')}>Save this location for future use</label>
        </div>
      )}
    </div>
  );
}

function OnlineFields({ form, onChange }) {
  return (
    <div className="form-grid">
      <div className="form-field">
        <span className="field-label">Join URL</span>
        <input id="onlineUrl" name="onlineUrl" type="url" value={form.onlineUrl} onChange={onChange} className="input" required />
      </div>
    </div>
  );
}

export default function EventModeFields({ form, onChange, locations }) {
  return (
    <>
      <div className="form-grid">
        <div className="form-field">
          <span className="field-label">Event Mode</span>
          <select id="eventMode" name="eventMode" value={form.eventMode} onChange={onChange} className="input">
            <option value="inPerson">In Person</option>
            <option value="online">Online</option>
          </select>
        </div>
      </div>

      {form.eventMode === 'inPerson'
        ? <LocationFields form={form} onChange={onChange} locations={locations} />
        : <OnlineFields form={form} onChange={onChange} />}
    </>
  );
}
